import { useMemo } from 'react';

import { useAutoLogoutBannerHeight } from 'corgi/common/hooks/useAutoLogoutBannerHeight';

export type BaseOffset = number | (number | null)[];

export const useStickyOffsetWithBanner = (baseOffset: BaseOffset): BaseOffset => {
  const autoLogoutBannerHeight = useAutoLogoutBannerHeight();

  return useMemo(() => {
    if (autoLogoutBannerHeight === 0) return baseOffset;

    if (Array.isArray(baseOffset)) {
      return baseOffset.map(offset =>
        typeof offset === 'number' ? autoLogoutBannerHeight + offset : autoLogoutBannerHeight,
      );
    }

    if (typeof baseOffset === 'number') {
      return autoLogoutBannerHeight + baseOffset;
    }

    return autoLogoutBannerHeight;
  }, [autoLogoutBannerHeight, baseOffset]);
};
